import type { RouteLocationNormalized } from 'vue-router'

export const DEFAULT_TITLE = 'Mobidic'

/** Titolo della rotta più annidata che lo definisce, altrimenti quello di default. */
export function applyRouteTitle(to: RouteLocationNormalized): void {
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title)

  document.title = (nearestWithTitle?.meta.title as string | undefined) ?? DEFAULT_TITLE
}
